import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

// ******************************************
//     表の色付け
// ******************************************
export class CustomTableLayout extends Plugin {
  init() {
    const editor = this.editor;
    // ドキュメントにフォーカスが当たったり、変更があればイベント起動
    editor.model.document.on('change', () => {
      // console.log('The Document has changed!');

      // ストライプテーブルのレイアウト
      void setTableLayout();
    });

    /**
     * ストライプテーブルのレイアウト
     */
    function setTableLayout() {
      for (let tidx = 0; tidx < 2; tidx++) {
        // tableインデックス
        let style_value;
        if (tidx == 0) {
          style_value = 'border-style:strip;';
        } else {
          style_value = 'border-style:stripborder;';
        }

        let tableCount = 1;
        document.querySelectorAll('table[style="' + style_value + '"]').forEach((stripTables) => {
          // 最大列数取得
          let maxcol = 0;
          // ヘッダー
          stripTables.querySelectorAll('table[style="' + style_value + '"] > thead > tr').forEach((trElement) => {
            let ths = trElement.querySelectorAll('th');
            if (maxcol < ths.length) {
              maxcol = ths.length;
            }
          });
          // ボディー
          stripTables.querySelectorAll('table[style="' + style_value + '"] > tbody > tr').forEach((trElement) => {
            let tds = trElement.querySelectorAll('td');
            if (maxcol < tds.length) {
              maxcol = tds.length;
            }
          });

          // 背景色を付ける行を設定
          let nuri = false;
          let nurirow = [];
          let idx = 0;
          stripTables.querySelectorAll('table[style="' + style_value + '"] tr').forEach((trElement, key) => {
            if (key > 0) {
              let ths = trElement.querySelectorAll('th');
              let tds = trElement.querySelectorAll('td');
              let collength = 0;
              if (ths.length > 0) {
                ths.forEach((th) => {
                  if (th.hasAttribute('colspan')) {
                    collength = collength + Number(th.getAttribute('colspan'));
                  } else {
                    collength++;
                  }
                });
              } else {
                tds.forEach((td) => {
                  if (td.hasAttribute('colspan')) {
                    collength = collength + Number(td.getAttribute('colspan'));
                  } else {
                    collength++;
                  }
                });
              }

              if (maxcol <= collength) {
                nuri = !nuri;
              }
              if (nuri) {
                nurirow[idx] = key;
                idx++;
              }
            }
          });

          // 背景色をセット
          stripTables.querySelectorAll('table[style="' + style_value + '"] tr').forEach((trElement, key) => {
            if (nurirow.includes(key)) {
              trElement.querySelectorAll('td').forEach((tdElement) => {
                tdElement.style.backgroundColor = '#d1d2d4';
              });
              trElement.querySelectorAll('th').forEach((thElement) => {
                thElement.style.backgroundColor = '#d1d2d4';
              });
            } else {
              trElement.querySelectorAll('td').forEach((tdElement) => {
                tdElement.style.backgroundColor = 'transparent';
              });
              trElement.querySelectorAll('th').forEach((thElement) => {
                thElement.style.backgroundColor = 'transparent';
              });
            }
          });

          tableCount++;
        });
      }
    }
  }
}
